import React, { Component } from 'react'
import MyPATLink from '../../common/MyPATLink'
import { LoginRequestV2 } from '../types/LoginRequestV2'
import {withRouter} from 'react-router'
import './LoginV2.css';
import config from '../../../config/config';
import { UserData } from '../types/UserData';
import { singleUserAxios } from '../../../services/axios';
import { MyPATToaster, ServerAlertAction } from '../../common';
import CancelIcon from '@material-ui/icons/Cancel';
import userActionsV2 from '../actions/userActionsV2';
import { connect } from 'react-redux';

export interface MyProps {
  loginSuccess: Function,
  loginData: any,
  history: any,
  location: any,
  userData: UserData,
  unAuthenticateUser: Function,
}

export interface LoginFormState {
  password: string,
  confirmPassword: string,
  isHidden: boolean,
  isHiddenConfirmPass: boolean,
  isPasswordCombination: boolean,
  disabledButton: boolean,
  colors: any[],
  strengths: any[],
  strength: any,
  validators: any,
  isPasswordLength: boolean,
  fontColor: any,
}
class SetPassword extends Component<MyProps, LoginFormState> {
  currentProps: MyProps;
  constructor(props: MyProps, state: any) {
    super(props)
    this.currentProps = props;
    this.state = {
      colors: ['#ddd', '#f21d1d', '#71e8f9', '#ffa547', '#3bb58a'],
      strengths: ['default', 'Weak', 'Average', 'Good', 'Strong'],
      validators: {
        min: false,
        max: false,
        digits: false,
        lower: false,
        upper: false,
        nonWords: false,
      },
      password: '',
      confirmPassword: '',
      isHidden: true,
      isHiddenConfirmPass: true,
      isPasswordCombination: true,
      disabledButton: true,
      strength: 0,
      isPasswordLength: false,
      fontColor: 'default-text',
    }
    this.showHide = this.showHide.bind(this);
    this.showHideConfirmPass = this.showHideConfirmPass.bind(this);
    this.newPassword = this.newPassword.bind(this);
    this.reEnterPassword = this.reEnterPassword.bind(this);
    this.backToPrevious = this.backToPrevious.bind(this);
    this.resetPassword = this.resetPassword.bind(this)
  }

  showHide() {
    this.setState({ isHidden: !this.state.isHidden })
  }

  showHideConfirmPass() {
    this.setState({ isHiddenConfirmPass: !this.state.isHiddenConfirmPass })
  }

  handlePasswordStrength(e: any) {
    this.setState({strength: e});
  }

  measureStrength(pass: string) {
    let score: any = 0;
    // award every unique letter until 5 repetitions
    const letters: any = {};
    for (let i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;
      score += 5.0 / letters[pass[i]];
      score += letters[pass[i]];
    }
    // bonus points for mixing it up
    let variations: any = {
      min: pass.length >= 6,
      max: pass.length >= 10,
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass) || /_/.test(pass) ,
    };
    let variationCount:any = 0;
    for (let check in variations) {
      variationCount += variations[check] ? 1 : 0;
      this.state.validators[check] = variations[check];
    }
    if (!variations['min']) variationCount = 0;
    return variationCount;
  }

  getColor(score: number) {
    let idx = 0;
    if (score == 6) {
      idx = 4;
    } else if (score >= 4) {
      idx = 3;
    } else if (score == 3) {
      idx = 2;
    } else if (score == 2) {
      idx = 1;
    }
    return idx;
  }

  isValid(value: any) {
    switch (value) {
      case 1:
        return { valid: this.state.validators['min'] };
      case 2:
        return {
          valid: this.state.validators['digits'] && this.state.validators['nonWords'],
        };
      case 3:
        return { valid: this.state.validators['lower'] && this.state.validators['upper'] };
    }
  }

  isCombination(): boolean {
    return !!(
      this.state.password.match(/[a-z]/) &&
      this.state.password.match(/[A-Z]/) &&
      this.state.password.match(/[@#$_]/) &&
      this.state.password.match(/[0-9]/)
    )
  }

  newPassword(event: any) {
    const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$_])(?=.{2,})");
    const mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{2,})");
    if(strongRegex.test(event.target.value)) {
      this.setState({ fontColor: "Strong-text" });
    } else if (event.target.value.length > 2) {
        this.setState({ fontColor: "Weak-text" });
    } else if (event.target.value.length === 0){
        this.setState({ fontColor: "default-text" });
    }
    const target = event.target.value;
    let c = this.getColor(this.measureStrength(target));
    this.setState({strength: c, password: target, isPasswordLength: true, isPasswordCombination: this.isCombination()});
  }

  reEnterPassword(event: any) {
    event.preventDefault();
    const target = event.target.value;
    this.setState({confirmPassword: target});
  }

  resetPassword() {
    let currentState = {
      password: this.state.password,
      appName: 'authors'
    };

    singleUserAxios.patch('v4/auth/password', currentState).then((res: any) => {
      if (res.code === 200) {
        localStorage.removeItem('tempAuthToken');
        localStorage.setItem('backToForgot', 'backFromForgot');
        this.props.history.push("/login")
      }
    });
  }

  backToPrevious() {
    localStorage.removeItem('tempAuthToken');
    localStorage.setItem('backToForgot', 'backFromForgot');
    this.props.history.push({pathname: "/login"})//, state:{ data: {
      // forgotData: this.props.location.state.data.forgotData,
      // username: this.props.location.state.data.username,
      // type: this.props.location.state.data.type,
      // countryCode: this.props.location.state.data.countryCode, 
      // countryFlag: this.props.location.state.data.countryFlag,
      // loginVia: 'forgot',
      // loginViaBack: 'forgotBack',
      // logout: true,
      // isPasswordSet: 'true',
      // }}})
  }

  componentDidMount(): void {
    
    let authData:any = localStorage.getItem(config.localStorageKey);
    authData = JSON.parse(authData);
    let firstTimeUser : any = localStorage.getItem('isFirstUser');
    firstTimeUser = JSON.parse(firstTimeUser);
    this.props.unAuthenticateUser();
    if (firstTimeUser) {
      localStorage.setItem('isFirstUser', 'true');
    }
    if (authData){
      localStorage.setItem('tempAuthToken', JSON.stringify(authData));
    }
  }

  render() {

    const { password, isPasswordLength, confirmPassword } = this.state
    return (
      <>
        <div className="login-container">
          <em></em><em></em><em></em><em></em>
          <div className="sign-in-container">
            {localStorage.getItem('isFirstUser') !== 'true' ? 
              <div onClick={this.backToPrevious} className="back-arrow">
                <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 12l12 12.002 2.12-2.123L5.742 13.5H24v-3H5.742l8.378-8.379L12 0 0 12z" fill="#333" />
                </svg>
              </div> : null
            }
            <img src="/assets/svg/authors-new-logo.svg" className="logoCms" alt="mypat logo" />
            <div className="signin-form setPwd">
              <h3 className="setPwd">Set New Password</h3>
              <div className="input-group">
                <div className="visible-password">
                  <input type={this.state.isHidden ? "password" : "text"} onChange={this.newPassword} name="password" placeholder="Enter a Password" maxLength={20}/>
                  <span onClick={this.showHide} className="eye-icon">
                    <img src={this.state.isHidden ? '/assets/img/singleSignin/togglePasswordHide.svg' : '/assets/img/singleSignin/togglePassword.svg'} alt="show password" />
                  </span>
                </div>
              </div>

              <div className="input-group gapTwoInput">
                <div className="visible-password mb0">
                  <input type={this.state.isHiddenConfirmPass ? "password" : "text"} onChange={this.reEnterPassword} name="confirmPassword" placeholder="Confirm Password" maxLength={20}/>
                  <span onClick={this.showHideConfirmPass} className="eye-icon">
                    <img src={this.state.isHiddenConfirmPass ? '/assets/img/singleSignin/togglePasswordHide.svg' : '/assets/img/singleSignin/togglePassword.svg'} alt="show password" />
                  </span>
                </div>
                {confirmPassword && password !== confirmPassword ? <div className="error">Password does not match!</div> : null}
                {password.length < 10 && password !== '' ? <div className="error">Password should be atleast 10 characters.</div> : null}
              </div>

              <div className="password-strength">
              {this.state.strengths.map((option, index) => (
                <span key={index.toString()} className={(index <= this.state.strength) ? this.state.strengths[this.state.strength] : 'default' }></span>
              ))}
              </div>

              {/* css name for text "strong-text", "average-text", "good-text", "weak-text", "default-text" */}
              {isPasswordLength ? 
              <p className={`${this.state.strengths[this.state.strength]}-text`}>{this.state.strengths[this.state.strength] === 'default' ? '' : this.state.strengths[this.state.strength] + ' Password'}</p> : null
              }
              <div className="strength-helper-text">
                <ul>
                  <li className={password.length > 0 ? (password.length >= 10 ? 'Strong-text' : 'Weak-text') : 'default-text'}>
                    A strong password typically contains 10-12 characters</li>
                  <li className={this.state.fontColor}>
                    Use a combination of atleast 1 lower case, 1 upper case, 1 number and 1 special character
                  </li>
                  <li className={password.length > 0 ? (password.length >= 6 && password !== 'password' ? 'Strong-text' : 'Weak-text') : 'default-text'}>
                  Do not set username or “password” as your password</li>
                </ul>
              </div >

              <div className="input-group">
                <button type="button" onClick={this.resetPassword} disabled={password.length < 10 || this.state.fontColor !== "Strong-text" || password !== confirmPassword} value="Change Password" className="submit-btn">
                  Change Password
                </button>
              </div >
            </div >

          </div>
          <div className="sign-in-footer">
            <div className="footer-left">
              <p>&copy; Copyright 2024-2025 Edfora. All Rights Reserved</p>
            </div>
            <div className="footer-right">
              <a href="/terms-of-use"> Terms of Use </a> 
              <span>|</span> 
              <a href="/privacy-policy">Privacy Policy</a>
              <span>|</span>
              <a href="/disclaimer">Disclaimer</a>
              <span>|</span>
              <a href="/copyright">Copyright</a>
            </div>
          </div>
        </div>
        </>

    )
  }
}

//@ts-ignore
const mapStateToProps = (state: any) => ({
});

const mapDispatchToProps = {
  unAuthenticateUser: userActionsV2.getUserLogout
};
//@ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withRouter(SetPassword));
